'use client';
import * as React from 'react';

var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgStore = function SvgStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15 8.625V9c0 1.65-1.35 3-3 3l-.01-.001c-1.66-.01-3-1.35-3-3v-.381",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15 8.625V9c0 1.65 1.34 2.99 3 2.99h.24-.01a2.77 2.77 0 0 0 2.75-2.76c0-.41-.12-.81-.33-1.16l-2.4-4c-.41-.68-1.14-1.1-1.93-1.1H7.61c-.8-.01-1.53.41-1.93 1.09l-2.4 3.99v-.01c-.21.34-.33.74-.33 1.15h-.001v-.01c-.01 1.51 1.23 2.75 2.75 2.75h.24l-.01-.001c1.65 0 3-1.35 3-3v-.38",
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.875 11.46v7.28c0 1.24-1.01 2.25-2.25 2.25H6.375l-.01-.001a2.256 2.256 0 0 1-2.25-2.26v-7.29M13.69 16.84h-3.38",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgStore as default };
//# sourceMappingURL=store.svg.js.map
